import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  BankTransactionDeleteInput,
  BankTransactionModel,
  BankTransactionMutationInput,
  BankTransactionUpdateInput,
} from './model';

export function useCreateBankTransaction(
  options?: UseMutationOptions<
    ApiResult<BankTransactionModel>,
    ApiError,
    BankTransactionMutationInput
  >,
): UseMutationResult<
  ApiResult<BankTransactionModel>,
  ApiError,
  BankTransactionMutationInput
> {
  return useMutation<
    ApiResult<BankTransactionModel>,
    ApiError,
    BankTransactionMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'bank-transactions',
      method: 'POST',
      classType: BankTransactionModel,
      body,
    });
  }, options);
}

export function useUpdateBankTransaction(
  options?: UseMutationOptions<
    ApiResult<BankTransactionModel>,
    ApiError,
    BankTransactionUpdateInput
  >,
): UseMutationResult<
  ApiResult<BankTransactionModel>,
  ApiError,
  BankTransactionUpdateInput
> {
  return useMutation<
    ApiResult<BankTransactionModel>,
    ApiError,
    BankTransactionUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `bank-transactions/${body.bankTransactionId}`,
      method: 'PUT',
      classType: BankTransactionModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteBankTransaction(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    BankTransactionDeleteInput
  >,
): UseMutationResult<
  { message: string },
  ApiError,
  BankTransactionDeleteInput
> {
  return useMutation<{ message: string }, ApiError, BankTransactionDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `bank-transactions/${body.bankTransactionId}/void`,
        method: 'PATCH',
      });
    },
    options,
  );
}
